export default __webpack_public_path__ + "static/media/bdedu3.5bf1a732.PNG";